<template>
  <div class="user-auth-status">
    <template v-if="isAuthenticated">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            text 
            v-bind="attrs" 
            v-on="on"
            class="user-menu-btn"
          >
            <v-icon left>{{ isAnonymous ? 'mdi-incognito' : 'mdi-account-circle' }}</v-icon>
            {{ displayName }}
            <v-icon right small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        
        <v-list>
          <v-list-item v-if="isAnonymous">
            <v-list-item-content>
              <anonymous-upgrade @upgrade-success="handleUpgradeSuccess" />
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item @click="handleLogout">
            <v-list-item-icon class="mr-2">
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sign Out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    
    <template v-else>
      <v-btn 
        text 
        @click="$router.push('/login')"
        class="login-btn"
      >
        <v-icon left>mdi-login</v-icon>
        Sign In
      </v-btn>
    </template>
  </div>
</template>

<script>
import AnonymousUpgrade from '@/components/AnonymousUpgrade.vue';

export default {
  name: 'UserAuthStatus',
  components: {
    AnonymousUpgrade
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    isAnonymous() {
      return this.$store.getters['auth/isAnonymous'];
    },
    user() {
      return this.$store.getters['auth/getUser'];
    },
    displayName() {
      if (!this.user) return 'Guest';
      if (this.isAnonymous) return 'Guest User';
      return this.user.email || this.user.displayName || 'User';
    }
  },
  methods: {
    async handleLogout() {
      try {
        await this.$store.dispatch('auth/logout');
        this.$router.push('/');
      } catch (error) {
        console.error('Logout error:', error);
      }
    },
    handleUpgradeSuccess() {
      // Show a success message or perform any actions after successful upgrade
      this.$emit('user-upgraded');
    }
  }
};
</script>

<style scoped>
.user-auth-status {
  display: flex;
  align-items: center;
}

.user-menu-btn, .login-btn {
  text-transform: none;
}
</style> 